import { Link } from 'react-router'

export type Breadcrumb = { name: string; path: string }

export function Breadcrumbs({
  className,
  items,
}: {
  className?: string
  items: Breadcrumb[]
}) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`post-breadcrumbs ${className ?? ''}`}
    >
      <ol>
        {items.map((item, index) => (
          <li key={item.path}>
            {index === items.length - 1 ? (
              <span aria-current="page">{item.name}</span>
            ) : (
              <Link to={item.path}>{item.name}</Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
